import axios from 'axios'
import router from '../router'

const service = axios.create({
  timeout: 60000,
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true
})
service.defaults.headers.post['Content-Type'] = 'application/json'

service.interceptors.request.use(config => {
  // 运行时动态 API 域名（小程序多环境支持）
  // 由 uni-H5 bridge 在 init 阶段通过 uni.getAccountInfoSync() 设置
  if (window.__API_BASE_URL__) {
    config.baseURL = window.__API_BASE_URL__
  }

  // 从localStorage获取token并添加到请求头
  const token = localStorage.getItem('token')

  JSON.parse(localStorage.getItem('customHeaders') || '[]').forEach(item => {
    if (item.enable && item.key && item.value) {
      config.headers[item.key] = item.value
    }
  })

  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }

  // 自定义 URL 覆盖（调试用）
  let customUrl = window.localStorage.getItem('CUSTOM_URL')
  if (customUrl) {
    config.baseURL = customUrl
  }

  console.log(config)
  return config
}, (error) => {
  return Promise.reject(error)
})

service.interceptors.response.use(response => {
  const responseCode = response.status

  if (responseCode === 200) {
    // 兼容后端返回的token失效、未登录等自定义code
    if (response.data && (response.data.code === 401 || response.data.code === 403 || response.data.code === 10001 || response.data.code === 10002 || response.data.code === 40003 || response.data.code === 40004)) {
      // 清理本地token
      localStorage.removeItem('token')
      // 避免死循环跳转
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
      return Promise.reject(new Error('登录已失效，请重新登录'))
    }
    return Promise.resolve(response.data)
  } else {
    return Promise.reject(response)
  }
}, error => {
  if (!error.response) {
    if (error.message.includes('timeout')) {
      return Promise.reject(new Error('亲~网络不给力，请稍后再操作(＞﹏＜)'))
    } else {
      return Promise.reject(new Error('亲，网络似乎出了点问题ㄟ( ▔, ▔ )ㄏ'))
    }
  }

  const responseCode = error.response.status

  switch (responseCode) {
    case 401:
    case 403:
      // 清理本地token
      localStorage.removeItem('token')
      // 避免死循环跳转
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
      break
    case 404:
      break
    default:
  }
  return Promise.reject(error)
})

export default service

export const uploadFile = formData => {
  const res = service.request({
    method: 'post',
    url: '/upload',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return res
}
